const url = "/api";

export async function getFilters() {
  let response = await fetch(`${url}/get_filter`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  let result = await response.json();
  return result;
}

export async function searchComplexes(formData) {
  let response = await fetch(`${url}/get_list_rc`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  let result = await response.json();
  return result;
}

export async function getComplexInfo(id) {
  let response = await fetch(
    `${url}/get_rc/${id}
    `,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  let result = await response.json();
  return result;
}

export async function getApartmentInfo(id) {
  let response = await fetch(`${url}/get_apartment/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  let result = await response.json();
  return result;
}

export async function getSearchInfo() {
  let response = await fetch(`${url}/get_search_info_list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  let result = await response.json();
  return result;
}

export async function getApartmentsInfo(formData) {
  let response = await fetch(`${url}/get_list_apartment`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  let result = await response.json();
  return result;
}

export async function sendInfo(formData) {
  let response = await fetch(`${url}/send-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
}
